import React from 'react';
import { HelpTip } from '@amzn/storm-ui';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { TooltipContentWrapper, TooltipLink } from './styles';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

// Temporary placeholder, to be changed
const learnMoreUrl = 'https://advertising.amazon.com/help';

const GlobalAccountTooltipContent = () => {
  const bundle = useAccountDropdownBundle();
  const tooltipText = bundle.getMessage(
    'account-switcher-list-headings-single-global-account-tooltip-text',
  );
  const tooltipLinkText = bundle.getMessage(
    'account-switcher-list-headings-single-global-account-tooltip-link',
  );

  return (
    <HelpTip tooltipProps={{ withCloseButton: false, position: 'bottom' }}>
      <TooltipContentWrapper>
        {tooltipText}{' '}
        <TooltipLink
          href={learnMoreUrl}
          target="_blank"
          {...getTaktAttributes(
            'global-account-tooltip-link',
            chromeComponents.HEADER,
          )}
        >
          {tooltipLinkText}
        </TooltipLink>
      </TooltipContentWrapper>
    </HelpTip>
  );
};

export default GlobalAccountTooltipContent;
